import React from 'react'

const Loading = (props) => {
	return (
		<div>Loading</div>
	)
}

export default Loading


// WEBPACK FOOTER //
// ./src/common/components/page/loading.js